import React from "react";
import styled from "styled-components";
import brandLight from '../../assets/img/logo.png';
import brandDark from '../../assets/img/logo.jpeg';

const MainBrand = styled.div`
   img{
    width : ${props => props.width};
    max-width: 100%;
    height: ${props => props.height};
   }
   .v-light & , & {
        .logo-dark{
           display : block ;     
        }
        .logo-light{
            display : none;    
        }
   }
    
   .v-dark & {
       .logo-dark{
           display : none ;     
        }
        .logo-light{
            display : block;    
        }
    }`;

const Brand = ({ width, height, alt, isFoot = false }) => {
    return (
        <MainBrand className="main-brand" width={width} height={height}>
            {isFoot ? 
            <img className="logo-dark" src={brandDark} alt={`${alt} - logo light`} style={{ width: '150px', height: 'auto' }} />
            : <>
                <img className="logo-light" src={brandLight} alt={`${alt} - logo dark`} style={{ width: '100px', height: 'auto' }} />
                <img className="logo-dark" src={brandLight} alt={`${alt} - logo dark`} style={{ width: '100px', height: 'auto' }} />
                </>
            }
        </MainBrand>
    );
}

MainBrand.defaultProps = { width: '80px', height: 'auto' }
Brand.defaultProps = { alt: "Pavansut Granito" }

export default React.memo(Brand);